import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "UNIT_FORM";
export const UnitFormAction = createFormAction(FORM_KEY);
